import React, { useMemo, useState } from "react";
import { EditorContext } from "../contexts/EditorContext.js";
import { EditorStateContext } from "../contexts/EditorStateContext.js";
import { useEditor } from "../hooks/useEditor.js";
import { LayoutGroup } from "./LayoutGroup.js";
function CodeMirrorInner(param) {
    let { children, ...config } = param;
    const [parent, setParent] = useState(null);
    const { view, state } = useEditor(parent, config);
    const editor = useMemo(()=>({
            view,
            setParent
        }), [
        view
    ]);
    return /*#__PURE__*/ React.createElement(EditorContext.Provider, {
        value: editor
    }, /*#__PURE__*/ React.createElement(EditorStateContext.Provider, {
        value: state
    }, children));
}
export function CodeMirror(props) {
    return /*#__PURE__*/ React.createElement(LayoutGroup, null, /*#__PURE__*/ React.createElement(CodeMirrorInner, props));
}
